<style scoped="scoped" lang="scss">
  .el-table--group {
    border: 1px solid #ebeef5 !important;
  }
.indicator_summary {
  .info {
    background-color: #F7F8FA;
    height: 28px;
    display: flex;
    margin-bottom: 12px;
    align-items: center;
    justify-content: flex-end;
    color: #419FFF;
    font-size: 12px;
    font-family: 'Microsoft YaHei UI';
  }


  .side {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419FFF;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }

    // 右侧
    .right {
      display: flex;
      align-items: center;
    }
  }

  .table {
    width: calc(100% - 0px);
    margin-top: 12px;

  }

}
</style>
<template>
  <div class="indicator_summary">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>
    <!--  信息-->
    <div class="info">
      <div class="info-item">
        {{$t('meiri09:00gengxinzuorishuju')}}
      </div>
    </div>
    <div>
      <!--  表单-->
      <el-form  size="mini" :inline="true" :model="conditions" class="demo-form-inline">
        <el-form-item :label="$t('suoshuzuzhi')">
          <yi_data_select :type="'organization'" :ids.sync="conditions.selectedOrgId" :idsPath.sync="conditions.orgId"></yi_data_select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getSummary" type="primary"
              plain="plain">
            {{$t('sousuo')}}
          </el-button>
          <el-button @click="reset">{{$t('chongzhi')}}
          </el-button>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form-item>
      </el-form>
    </div>
    <!--  汇总明细-->
    <div class="side">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{$t('huizongmingxi')}}</span>
      </div>
<!--      <div class="right">-->
<!--        <el-button size="mini" type="default" @click="showShowTableColumn('equipmentProduction')"><i-->
<!--            class="yicon yicon-config_column"></i>-->
<!--        </el-button>-->
<!--      </div>-->
    </div>

    <!--  表格-->
    <div class="table">
      <el-table stripe max-height="600" :data="summary.tableData" size="mini" border
          style="width: 100%" v-loading="searchLoading"
          :header-cell-style="{background: '#F5F7FA',color:'#606266', 'font-weight':'700', height:'48px', padding:'0px'}">
        <el-table-column prop="summaryDateDesc" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column :label="$t('shebeiKPI')" :show-overflow-tooltip="true">
          <el-table-column prop="equipmentRunCount" :label="$t('kaijishuliang')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.equipmentRunCount ? '#419FFF' : '#419FFF' }" @click="handleColumnClick('equipKpi', scope.row)">
                {{scope.row.equipmentRunCount}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="oee" :label="$t('OEE')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.oee ? '#419FFF' : '#419FFF' }" @click="handleColumnClick('equipKpi', scope.row)">
<!--{{((scope.row.oee).toFixed(1))+'%'}}-->
                {{scope.row.oee==null?'':(scope.row.oee).toFixed(1)+'%'}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('shengchantongji')" :show-overflow-tooltip="true">
          <el-table-column prop="materialCount" :label="$t('chanpinzonglei')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.materialCount ? '#419FFF' : '#419FFF' }" @click="handleColumnClick('proSum',scope.row)">
                {{scope.row.materialCount}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true">
          <el-table-column prop="materialProduction" :label="$t('chanpinchanliang')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.materialProduction ? '#419FFF' : '#419FFF' }" @click="handleColumnClick('proSum',scope.row)">
                {{scope.row.materialProduction}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="$t('zhiliangtongji')" :show-overflow-tooltip="true">
          <el-table-column prop="badQuantityRate" :label="$t('liangpinlv')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.badQuantityRate ? '#419FFF' : '#419FFF' }" @click="handleColumnClick('qualitySum',scope.row)">
                {{scope.row.badQuantityRate==null?'':(scope.row.badQuantityRate).toFixed(1)+'%'}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true">
          <el-table-column prop="badQuantitySum" :label="$t('buliangpinshu')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div :style="{ color: scope.row.badQuantitySum ? '#419FFF' : '#419FFF' }" @click="handleColumnClick('qualitySum',scope.row)">
                {{scope.row.badQuantitySum}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "web_report_equipment_capacity_statistics_indicator_summary_indicator_summary",
  props: {
    parentParams: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      searchLoading: false,
      conditions: {
        selectedOrgId: this.store.state.organizations[0]['id']
      },
      summary: {
        tableData: [],
        tableColumn: [],
        currentEquipmentkpi: this.$t('shebeiKPI'),
      },
    }
  },
  mounted() {
    this.conditions.selectedOrgId=this.store.state.organizations[0]['id']
    this.getSummary()
  },
  methods: {
    handleColumnClick(type, row) {
      this.selectedRow = row;
      this.$emit('navTo', {
        type: type,
        row: {
          ...row,
          orgId: this.conditions.selectedOrgId,
          selectedOrgId: this.conditions.orgId,
        },
      })
      if(row.summaryDateDesc){
        this.utils.event_hub.$emit('STATISTICS_DETAIL_REFRESH')
      }
    },
    reset() {
      this.conditions.selectedOrgId=this.store.state.organizations[0]['id']
      this.$nextTick(()=>{
        this.getSummary()
      })
    },
    // 排序
    sortProp(a, b) {
      return a.prop - b.prop
    },
    getSummary() {
      this.searchLoading = true;
      let requestParam = {
        orgId:this.conditions.selectedOrgId,
        orderBy: 'sort asc',
      }
      return this.http.get('/web/report/page/equipment_capacity_summary?' + this.qs.stringify(requestParam)).then(response => {
        const rows = response.data.rows || [];
        this.searchLoading = false;
        if (rows.length > 0) {
          const item = rows[0]
          for (let i in item) {
            if (i === 'summaryDateDesc') {
              continue
            }
            if (i === 'equipmentRunCount') {
              continue
            }
            if (i === 'oee') {
              continue
            }
            if (i === 'materialCount') {
              continue
            }
            if (i === 'materialProduction') {
              continue
            }
            if (i === 'badQuantityRate') {
              continue
            }
            if (i === 'badQuantitySum') {
              continue
            }
            this.summary.tableColumn.push({
              label: i,
              prop: i,
              sortable: false
            })
          }
          this.summary.tableColumn.sort(this.sortProp);
          this.summary.tableData = rows;
        }
      }).catch(error => {
        this.$message.error(this.$t(error));
        this.searchLoading = false;
      });
    }
  }
}
</script>
